import { render, staticRenderFns } from "./LastSentLoyaltyMoments.vue?vue&type=template&id=00b6ba0f&"
import script from "./LastSentLoyaltyMoments.vue?vue&type=script&lang=js&"
export * from "./LastSentLoyaltyMoments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports